import {useEffect, useMemo, useState} from "react";
import {useSelector} from "react-redux";
import {isLoaded, useFirestoreConnect} from "react-redux-firebase";
import {selectCategoryDoc} from "../constant/selectors";


const formatCategories = (list) => {
    return list?.map(one => {
        return {
            ...one,
            children: one.children.map(({id, key, label}) => ({label, id: key || id}))
        }
    }) || []
}

export default function useCategories() {
    const [loading, setIsLoading] = useState(false);
    const getCategories = useSelector(selectCategoryDoc);

    const categories = useMemo(() => formatCategories(getCategories?.at(0)?.data), [getCategories])

    useEffect(() => setIsLoading(!isLoaded(getCategories)), [getCategories])

    useFirestoreConnect(() => [
        {
            collection: 'categories',
            doc: "list",
            storeAs: 'categories'
        }
    ]);
    

    return {categories, loading}
}